import React, { useMemo } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Builder from "@/pages/Builder";
import AuthCallback from "@/pages/AuthCallback";
import PublicSite from "@/pages/PublicSite";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentReturn";

// CRITICAL: Detect session_id in the URL hash *during render* (not useEffect)
// so we handle the OAuth callback BEFORE any /me check runs.
function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/builder/:projectId" element={<Builder />} />
            <Route path="/s/:slug" element={<PublicSite />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Landing />} />
        </Routes>
    );
}

const TOAST_OPTIONS = {
    style: {
        borderRadius: 4,
        border: "1px solid hsl(var(--border))",
        background: "hsl(var(--card))",
        color: "hsl(var(--foreground))",
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 12,
        letterSpacing: "0.04em",
    },
};

export default function App() {
    // Memoized to satisfy React lint (stable prop identity) — see review recommendation.
    const toastOptions = useMemo(() => TOAST_OPTIONS, []);
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster position="bottom-right" toastOptions={toastOptions} />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
